import React from 'react';
import './PromoModal.css';

/**
 * PromoModal
 * Pops up using usePopupModal's isOpen/closeModal state.
 *
 * Props:
 * - isOpen: boolean
 * - onClose: function
 * - onGetQuote: function (called when CTA button is clicked)
 * - imageSrc: optional image for the top of the modal
 */
const PromoModal = ({ isOpen, onClose, onGetQuote, imageSrc }) => {
  if (!isOpen) return null;

  return (
    <div className="promo-modal-overlay" onClick={onClose}>
      <div className="promo-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="promo-modal-close" onClick={onClose} aria-label="Close">
          &times;
        </button>

        {imageSrc && (
          <div className="promo-modal-image-container">
            <img src={imageSrc} alt="Promo" className="promo-modal-image" />
          </div>
        )}

        <div className="promo-modal-body">
          <h2>Limited Time Offer!</h2>
          <p>Get a free, no-obligation quote on your tree service today.</p>
        </div>

        <div className="promo-modal-footer">
          <button
            className="promo-modal-cta"
            onClick={() => {
              onGetQuote && onGetQuote();
              onClose();
            }}
          >
            Get a Free Quote
          </button>
        </div>
      </div>
    </div>
  );
};

export default PromoModal;
